import React, { FC, ReactElement, useState } from 'react';
import { Card, Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../redux_store/reduxStore';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { BakeasyAppBar } from '../../components/layouts/BakeasyAppBar';
import { BakeasyButton } from '../../components/buttons/BakeasyButton';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import { authActions } from '../../redux_store/slices/ManageMasterPasswordSlice';

export const MasterPassword: FC = (): ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [password, setPassword] = useState<string>('');
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = (): void => setShowPassword(!showPassword);

  function onSubmit(password: any) {
    if (!password) {
      let msg = `${t('PASSWORD_IS_REQUIRED')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return;
    }

    if (password?.length < 5) {
      let msg = `${t('PASSWORD_MIN_LENGTH_ERROR')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return;
    }
    dispatch(authActions.getUpadatedMasterPassword({ password }));
  }

  return (
    <Grid>
      <Grid item>
        <BakeasyAppBar
          title={t('SET_MASTER_PASSWORD')}
          onBackClick={() => {
            navigate(-1);
          }}
        />
      </Grid>
      <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
        <Grid container alignItems="center" justifyContent="center">
          <Card sx={{ margin: 1, padding: 2, marginBottom: 5 }}>
            <Grid container justifyContent="center" padding={1}>
              <TextField.Password
                name="password"
                label={t('PASSWORD')}
                value={password}
                type="password"
                placeHolder={t('ENTER_MASTER_PASSWORD')}
                showPassword={showPassword}
                onChange={(event: any) => {
                  setPassword(event.target.value);
                }}
                onIconClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  handleClickShowPassword();
                }}
              />

              <Grid sx={{ margin: 2 }}></Grid>

              <BakeasyButton
                fullWidth={true}
                label={t('SET_PASSWORD')}
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  onSubmit(password);
                }}
              />
            </Grid>
          </Card>
        </Grid>
      </Paper>
    </Grid>
  );
};
